import { render } from "./Blogs-page.vue?vue&type=template&id=1f55c1de"
import script from "./Blogs-page.vue?vue&type=script&lang=js"
export * from "./Blogs-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__